export function normalizeDraftLabel(label) {
  if (label == null || label === '') return '';
  const s = String(label).trim();
  const legacy = s.match(/^Draft\s+0*(\d+)$/i);
  if (legacy) return String(Number(legacy[1]));
  return s;
}

export function draftDeLinea(linea, defaultDraft = '1') {
  return normalizeDraftLabel(linea?.draft_label) || defaultDraft;
}

/** Identificador de contenedor dentro de un draft (correlativos se reinician por draft). */
export function contenedorEnDraftKey(linea, defaultDraft = '1') {
  const draft = draftDeLinea(linea, defaultDraft);
  const cont = Number(linea?.correlativo_contenedor) || 1;
  return `${draft}|${cont}`;
}

export function mismoGrupoContenedor(a, b, defaultDraft = '1') {
  return (
    draftDeLinea(a, defaultDraft) === draftDeLinea(b, defaultDraft) &&
    (Number(a?.correlativo_contenedor) || 1) === (Number(b?.correlativo_contenedor) || 1)
  );
}

/**
 * Opcional: compacta correlativos a 1…n dentro de cada draft (orden de aparición).
 * No se invoca al mover draft ni al emitir Excel; el correlativo es por draft.
 */
export function reenumerarCorrelativosPorDraft(lineas, draftIds = ['1']) {
  const drafts = (draftIds || ['1']).map((d) => String(d));
  const next = (lineas || []).map((ln) => ({ ...ln }));
  const defaultDraft = drafts[0] || '1';

  for (const draft of drafts) {
    const idxs = next
      .map((ln, idx) => ({ ln, idx }))
      .filter(({ ln }) => draftDeLinea(ln, defaultDraft) === draft)
      .sort((a, b) => {
        const ca = Number(a.ln.correlativo_contenedor) || 1;
        const cb = Number(b.ln.correlativo_contenedor) || 1;
        if (ca !== cb) return ca - cb;
        return a.idx - b.idx;
      });

    const contToNew = new Map();
    let seq = 0;
    for (const { ln, idx } of idxs) {
      const oldCont = Number(ln.correlativo_contenedor) || 1;
      if (!contToNew.has(oldCont)) {
        seq += 1;
        contToNew.set(oldCont, seq);
      }
      next[idx] = { ...next[idx], correlativo_contenedor: contToNew.get(oldCont) };
    }
  }

  const extraDrafts = new Set(
    next.map((ln) => draftDeLinea(ln, defaultDraft)).filter((d) => !drafts.includes(d))
  );
  for (const draft of extraDrafts) {
    const idxs = next
      .map((ln, idx) => ({ ln, idx }))
      .filter(({ ln }) => draftDeLinea(ln, defaultDraft) === draft)
      .sort((a, b) => {
        const ca = Number(a.ln.correlativo_contenedor) || 1;
        const cb = Number(b.ln.correlativo_contenedor) || 1;
        if (ca !== cb) return ca - cb;
        return a.idx - b.idx;
      });
    const contToNew = new Map();
    let seq = 0;
    for (const { ln, idx } of idxs) {
      const oldCont = Number(ln.correlativo_contenedor) || 1;
      if (!contToNew.has(oldCont)) {
        seq += 1;
        contToNew.set(oldCont, seq);
      }
      next[idx] = { ...next[idx], correlativo_contenedor: contToNew.get(oldCont) };
    }
  }

  return next;
}

export function maxCorrelativoEnDraft(lineas, draft, defaultDraft = '1') {
  const d = normalizeDraftLabel(draft) || defaultDraft;
  return (lineas || []).reduce((max, ln) => {
    if (draftDeLinea(ln, defaultDraft) !== d) return max;
    return Math.max(max, Number(ln.correlativo_contenedor) || 0);
  }, 0);
}

function contenedoresUnicosEnDraft(lineas, draft, defaultDraft = '1') {
  const conts = new Set();
  for (const ln of lineas || []) {
    if (draftDeLinea(ln, defaultDraft) !== draft) continue;
    const c = Number(ln?.correlativo_contenedor);
    if (!Number.isFinite(c) || c < 1) return null;
    conts.add(c);
  }
  return conts;
}

export const MENSAJE_CONTENEDORES_NO_CONSECUTIVOS =
  'Los números de contenedor deben ser consecutivos sin saltos.';

/**
 * Por cada draft con líneas, los correlativos de contenedor deben ser exactamente 1…n.
 */
export function validarContenedoresConsecutivosPorDraft(
  lineas,
  { modoDraft = 'uno', draftIds = ['1'] } = {}
) {
  const defaultDraft = draftIds[0] || '1';
  const modoVarios = modoDraft === 'varios';
  const draftsConLineas = new Set(
    (lineas || []).map((ln) => draftDeLinea(ln, defaultDraft))
  );
  const draftsARevisar = modoVarios ? [...draftsConLineas] : [defaultDraft];

  for (const draft of draftsARevisar) {
    const conts = contenedoresUnicosEnDraft(lineas, draft, defaultDraft);
    if (conts === null) {
      return MENSAJE_CONTENEDORES_NO_CONSECUTIVOS;
    }
    if (!conts.size) continue;
    const sorted = [...conts].sort((a, b) => a - b);
    for (let i = 0; i < sorted.length; i += 1) {
      if (sorted[i] !== i + 1) {
        return MENSAJE_CONTENEDORES_NO_CONSECUTIVOS;
      }
    }
  }
  return '';
}
